
define( 'FORCES_AND_MOTION_BASICS/../nls/ta/forces-and-motion-basics-strings',{
          "none": "ஒருவருமில்லை",
          "force": "விசை",
          "values": "மதிப்புகள்",
          "frictionTitle": "உராய்வு",
          "redWins": "சிவப்பு அணி வெற்றி!",
          "frictionForce": "உராய்வு விசை",
          "pause": "இடைநிறுத்தம்",
          "friction": "உராய்வு",
          "forces-and-motion-basics.name": "விசை மற்றும் நகர்ச்சி அடிப்படைகள்",
          "appliedForce": "செலுத்தப்படும் விசை",
          "leftForce": "இடப்பக்கம் விசை",
          "massDisplay.pattern": "{0} கிலோ கிராம்",
          "rightForce": "வலப்பக்கம் விசை",
          "sound": "ஒலி ",
          "lots": "அதிகளவான",
          "forces": "தள்ளு விசை",
          "motion": " நகர்ச்சி",
          "tugOfWar": "கயிறு இழுக்கும் போட்டி",
          "go": "புறப்படு",
          "newtons.n": "நியூட்டன்(N)",
          "sumOfForcesEqualsZero": "ஒட்டு மொத்த விசை = 0",
          "blueWins": "நீல நிற அணி வெற்றி!",
          "speed": "வேகம்",
          "sumOfForces": "ஒட்டு மொத்த விசை",
          "return": "திரும்ப போ",
          "translation.credits": "திலீபன் ஸ்டாலின்\nwww.stemd4schools.com",
          "newtons": "நியூட்டன்",
          "masses": "பருமம்",
          "forceReadout.pattern": "{0}நியூட்டன்"
        } );